<template>
  <div class="container">
    <div class="wrap">
      <div class="box-con box-con-info z-flex z-flex-between">
        <div class="img-wrap">
          <el-image class="img" fit="cover" :src="img"></el-image>
        </div>
        <div class="info-wrap">
          <div class="title">
            {{title}}
          </div>
          <div class="info-item z-flex">
            <div class="info-item-l">分&emsp;&emsp;类：</div>
            <div class="info-item-r">{{category}}</div>
          </div>
          <div class="info-item z-flex teachers-item">
            <div class="info-item-l">主&emsp;&emsp;讲：</div>
            <div class="info-item-r">
              <el-tag size="small">{{teacher}}</el-tag>
            </div>
          </div>
          <div class="info-item z-flex">
            <div class="info-item-l">简&emsp;&emsp;介：</div>
            <div class="info-item-r">{{desc}}</div>
          </div>
          <div class="info-bottom z-flex z-flex-between">
            <div class="btn-group z-flex">
              <el-button class="btn" type="primary" @click="playVideo(0)">开始学习</el-button>
              <el-button class="btn btn-collect btn-iscollect" type="primary" plain v-if="isCollect" @click="collect">
                <i class="iconfont icon-yishoucang"></i>
                <span>已收藏</span>
              </el-button>
              <el-button class="btn btn-collect" v-else @click="collect">
                <i class="iconfont icon-shoucang"></i>
                <span>收藏</span>
              </el-button>
              <span class="view-num">{{viewNum}}人正在学习</span>
            </div>
            <div class="share z-flex">分享至：<i class="iconfont icon-weixin"></i></div>
          </div>
        </div>
      </div>
      <div class="box-con box-con-content">
        <el-tabs v-model="activeContent">
          <el-tab-pane label="课程介绍" name="intro">
            <div class="content-bd">
              <div class="intro" v-html="intro"></div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="课程目录" name="catelog">
            <div class="content-bd">
              <div class="catelog-list">
                <div class="item z-flex z-flex-between" v-for="(item,index) in videos" :key="index" @click="playVideo(index)">
                  <div class="item-l z-flex">
                    <i class="iconfont icon-bofang"></i>
                    <span>{{item.title}}</span>
                  </div>
                  <div class="item-r">{{item.duration}}</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- video弹窗 -->
    <el-dialog
      class="dialog-video"
      :title="videoTitle"
      :visible.sync="showDialogVideo"
      :close-on-click-modal="false"
      width="880px"
    >
      <div style="width: 100%;height: 500px">
        <video-player class="video-player vjs-custom-skin"
                      ref="videoPlayer"
                      :playsinline="true"
                      :options="playerOptions"
                      @play="onPlayerPlay($event)"
                      @pause="onPlayerPause($event)"
                      @ended="onPlayerEnded($event)"
                      @waiting="onPlayerWaiting($event)"
                      @playing="onPlayerPlaying($event)"
                      @canplay="onPlayerCanplay($event)"
        >
        </video-player>
      </div>

    </el-dialog>
    <!-- 购买弹窗 -->
    <el-dialog
      class="dialog-buy"
      title="提示"
      :visible.sync="showDialogBuy"
      width="600px"
    >
      <div class="text z-flex">
        <i class="el-icon-warning" style="font-size:22px;color:#f1a129;margin-right:15px"></i>
        <p>您的社员已到期该功能无法使用，请开通后继续使用</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button>购买本节课程<span class="price">￥{{curPrice}}</span></el-button>
        <el-button type="primary">购买会员</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { videoPlayer } from 'vue-video-player'
  import 'video.js/dist/video-js.css'
export default {
  components: {
    videoPlayer
  },
  data() {
    return {
      id:0,
      isCollect:false,
      img:'http://edu.pai2345.com/storage/images/NFGCV4lwhU4ZuRPwnbj2OF6qcx7dLJe8HwljJYy4.png',
      title:'',
      desc:'',
      category:'',
      teacher:'',
      viewNum:888,
      activeContent:'intro',
      intro: '',
      videos:[],
      showDialogVideo:false,
      videoId:'',
      videoTitle:'',
      videoUrl:'',
      showDialogBuy:false,
      curPrice:'99',
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [],
        poster: 'https://dyyxclub.oss-cn-hangzhou.aliyuncs.com/images/grTxWErKrA2t308qPgSayM3vlBZ0bLnokPZvSiJG.bmp', // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: true, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },
    };
  },
  computed: {
    
  },
  mounted() {
    this.id = this.$route.query.id;
    this.$axios.api.eduCourseInfo({id: this.id}, (res) => {
      if (res.code == 200) {
        this.title = res.data.course.title;
        this.intro = res.data.course.original_desc;
        this.img = res.data.course.thumb;
        this.desc = res.data.course.short_description;
        this.category = res.data.course.category;
        this.teacher = res.data.course.teacher;
        this.viewNum = res.data.course.view_num;
        this.isCollect = res.data.islike > 0 ? true : false;
        this.isVip = res.data.isVip;
        this.isBuy = res.data.isBuy;
        this.price = res.data.course.charge;
        for(let i = 0; i < res.data.videos.length; i++) {
          let video = res.data.videos[i];
          this.videos.push({
            id: video.id,
            title: video.title,
            url: video.url.replace("https://video.pai2345.com", "https://videoqtclub.pai2345.com"),
            duration: this.second(video.duration)
          });
        }
      }
    });
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    },
    // 收藏
    collect(){
      if (!this.$helper.isLogin()) {
        return this.$parent.showLogin();
      }
      let status = this.isCollect ? 0 : 1;
      this.$axios.api.request({
        url: "/api/qtclub/user/collectSubmit",
        data: {
          object: 'edu_course',
          object_id: this.id,
          status: status,
        }
      }, (res) => {
        if(res.data.status == 1){
          this.isCollect = true;
          this.$message.success('已收藏！');
          this.$myFun.toast('已收藏');
        }else{
          this.isCollect = false;
          this.$message.success('已取消收藏！');
        }
      })
    },
    // 分享
    share(){

    },
    second(value) {
      var theTime = parseInt(value);// 秒
      var middle = 0;// 分
      var hour = 0;// 小时
      if(theTime >= 60) {
        middle = parseInt(theTime/60);
        theTime = parseInt(theTime%60);
        if(middle >= 60) {
          hour = parseInt(middle/60);
          middle = parseInt(middle%60);
        }
      }
      var result = parseInt(theTime);
      if(middle > 0) {
        result = parseInt(middle) + ":" + result;
      }
      if(hour> 0) {
        result = parseInt(hour) + ":" + result;
      }
      return result;
    },
    //播放
    playVideo(index){
      if (!this.$helper.isLogin()) {
        return this.$parent.showLogin();
      }
      if(!this.isBuy){
        this.showDialogVideo = false;
        this.showDialogBuy = true;
        return;
      }
      this.videoId = this.videos[index].id;
      this.videoTitle = this.videos[index].title;
      this.videoUrl = this.videos[index].url;
      this.showDialogVideo = true;
      this.$nextTick(()=>{
        this.$refs.videoPlayer.player.src(this.videoUrl);
      })
    },
    //播放回调
    onPlayerPlay(player){
      if (!this.$helper.isLogin()) {
        player.pause();
      }
      if(!this.isBuy){
        player.pause();
        this.showDialogVideo = false;
        this.showDialogBuy = true;
      }
      this.watchRecords(player.cache_.currentTime);
    },
    // 暂停回调
    onPlayerPause(player) {
      this.watchRecords(player.cache_.currentTime);
      console.log(player);
    },
    // 视频播完回调
    onPlayerEnded(player) {
      this.watchRecords(player.cache_.currentTime);
      console.log(player);
    },
    // 已开始播放回调
    onPlayerPlaying(player) {
      console.log(player);
    },
    // DOM元素上的readyState更改导致播放停止
    onPlayerWaiting(player) {
      console.log(player)
    },
    //媒体的readyState为HAVE_FUTURE_DATA或更高
    onPlayerCanplay(player) {
      player.play();
    },
    //记录播放时长
    watchRecords(time){
      this.$axios.api.eduWatchRecords({course_id: this.id, video_id: this.videoId, time: time}, (res) => {
        if (res.code != 200) {
          console.log("记录播放时长失败")
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.box-con-info{
  padding: 20px;
  margin-bottom: 20px;
  align-items: flex-start;
  .img-wrap{
    width:600px;
    height:300px;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    .img{
      width:100%;
      height:100%;
      object-fit: cover;
    }
  }
  .info-wrap{
    width:calc(100% - 620px);
    color: #777;
    font-size: 14px;
    .title{
      font-size: 18px;
      font-weight: 700;
      vertical-align: middle;
      @include textOverflowNum(2);
      margin-bottom: 15px;
      color: #333;
      vertical-align: middle;
      .el-tag{
        font-weight: normal;
        margin-right: 5px;
      }
    }
    .info-item{
      margin: 20px 0;
      .info-item-l{
        width:80px;
      }
      .info-item-r{
        flex: 1;
      }
    }
    .teachers-item{
      .info-item-r{
        margin-bottom: -10px;
      }
      .el-tag{
        margin: 0 10px 10px 0;
      }
    }
    .info-bottom{
      padding-top: 20px;
      border-top: $borderDotted;
      .btn{
        padding: 0 30px;
        height: 40px;
        .iconfont{
          margin-right: 5px;
        }
      }
      .view-num{
        color: #999;
        margin-left: 20px;
      }
      .share{
        .icon-weixin{
          font-size: 30px;
          cursor: pointer;
          color: $colorGreen;
        }
      }
    }
  }
}
.box-con-content{
  ::v-deep .el-tabs__item{
    height: 50px;
    box-sizing: border-box;
    line-height: 50px;
    font-size: 18px;
    padding:0 20px!important;
  }
  ::v-deep .el-tabs__nav-wrap::after{
    height:1px;
  }
  .content-bd{
    padding: 5px 20px 20px;
    .intro{
      ::v-deep img{
        max-width: 100%;
      }
      ::v-deep p{
        margin:10px 0;
      }
    }
    .catelog-list{
      .item{
        padding:20px 0;
        border-bottom: $borderDotted;
        cursor: pointer;
        .item-l{
          font-size: 17px;
          flex: 1;
          margin-right: 30px;
          .icon-bofang{
            font-size: 22px;
            margin-right: 10px;
            color: #999;
          }
          span{
            flex: 1;
          }
        }
        .item-r{
          color: #999;
        }
        &:hover{
          .item-l{
            color: $colorMain;
            .icon-bofang{
              color: $colorMain;
            }
          }
        }
      }
    }
  }
}
.dialog-video{
  ::v-deep .el-dialog__title{
    width: calc(100% - 100px);
    @extend %textOverflow;
    display: inline-block;
  }
  .video-player{
    width: 100%;
  }
}
</style>
